import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Clipboard = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = '#29C452', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 25 25"
      fill="none"
      {...rest}
    >
      <path
        opacity="0.4"
        d="M9.60889 14.7842L11.1089 16.2842L15.1089 12.2842"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2988 6.08423H14.2988C16.2988 6.08423 16.2988 5.08423 16.2988 4.08423C16.2988 2.08423 15.2988 2.08423 14.2988 2.08423H10.2988C9.29883 2.08423 8.29883 2.08423 8.29883 4.08423C8.29883 6.08423 9.29883 6.08423 10.2988 6.08423Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2988 4.10425C19.6288 4.28425 21.2988 5.51425 21.2988 10.0842V16.0842C21.2988 20.0842 20.2988 22.0842 15.2988 22.0842H9.29883C4.29883 22.0842 3.29883 20.0842 3.29883 16.0842V10.0842C3.29883 5.52425 4.96883 4.28425 8.29883 4.10425"
        stroke={stroke}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Clipboard.displayName = 'Clipboard';
